// Module
var code = `<fdx-modal-hoc modal-theme="{{\$ctrl.modalTheme}}" modal-title="{{\$ctrl.title}}" submit-button="false" cancel-button="false" on-cancel="\$ctrl.onCancel()"> <span ng-if="\$ctrl.body">{{ \$ctrl.body }}</span> <span ng-if="\$ctrl.bodyHTML" ng-bind-html="\$ctrl.bodyHTML"></span> </fdx-modal-hoc> `;
// Exports
module.exports = code;